<template>
    <div>
        <calendar-navigation
            :meta="meta"
            view="week"
            :show-view-switch="showViewSwitch"
            @set-view="setView"
            @set-date="setDate"
        ></calendar-navigation>

        <!-- Add classes for tailwind whitelist -->
        <div class="hidden sm:col-start-1"></div>
        <div class="hidden sm:col-start-2"></div>
        <div class="hidden sm:col-start-3"></div>
        <div class="hidden sm:col-start-4"></div>
        <div class="hidden sm:col-start-5"></div>
        <div class="hidden sm:col-start-6"></div>
        <div class="hidden sm:col-start-7"></div>

        <layout-box>
            <div
                ref="container"
                class="flex flex-col flex-auto overflow-auto bg-white dark:bg-zinc-800 isolate h-[70vh] min-h-[680px]"
            >
                <div style="width: 165%" class="flex flex-col flex-none max-w-full sm:max-w-none md:max-w-full">
                    <div
                        ref="containerNav"
                        class="sticky top-0 z-30 flex-none bg-white shadow dark:bg-zinc-800 ring-1 ring-black/5 sm:pr-8"
                    >
                        <div class="grid grid-cols-7 text-sm leading-6 text-gray-500 sm:hidden">
                            <button
                                v-for="day in days"
                                :key="day.date"
                                type="button"
                                class="flex flex-col items-center pt-2 pb-3"
                            >
                                {{ day.dayLetter }}
                                <span
                                    class="flex items-center justify-center w-8 h-8 mt-1 font-semibold text-gray-900 dark:text-zinc-50"
                                    :class="[
                                        day.isToday && !day.isSelected
                                            ? 'text-brand-600 dark:text-brand-600'
                                            : 'text-gray-900 dark:text-zinc-50',
                                        day.isSelected ? 'bg-gray-100 dark:bg-zinc-900' : '',
                                    ]"
                                    @click="setDate(day)"
                                    >{{ day.day }}</span
                                >
                            </button>
                        </div>

                        <div
                            class="hidden grid-cols-7 -mr-px text-sm leading-6 text-gray-500 border-r border-gray-100 divide-x divide-gray-100 dark:border-zinc-700 dark:divide-zinc-700 sm:grid"
                        >
                            <div class="col-end-1 w-14" />
                            <div v-for="day in days" :key="day.date" class="flex items-center justify-center py-3">
                                <span
                                    >{{ day.dayName }}
                                    <span
                                        :class="[
                                            day.isToday
                                                ? 'ml-1.5 inline-flex h-8 w-8 items-center justify-center rounded-full bg-brand-600 font-semibold text-white'
                                                : 'items-center justify-center font-semibold text-gray-900 dark:text-zinc-50',
                                        ]"
                                        >{{ day.day }}</span
                                    ></span
                                >
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-auto">
                        <div
                            class="sticky left-0 z-10 flex-none bg-white dark:bg-zinc-800 w-14 ring-1 ring-gray-100 dark:ring-gray-700"
                        />
                        <div class="grid flex-auto grid-cols-1 grid-rows-1">
                            <!-- Horizontal lines -->
                            <div
                                class="grid col-start-1 col-end-2 row-start-1 divide-y divide-gray-100 dark:divide-zinc-700"
                                style="grid-template-rows: repeat(48, minmax(3.5rem, 1fr))"
                            >
                                <div ref="containerOffset" class="row-end-1 h-7" />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        0:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        1:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        2:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        3:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        4:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        5:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        6:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        7:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        8:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        9:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        10:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        11:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        12:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        13:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        14:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        15:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        16:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        17:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        18:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        19:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        20:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        21:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        22:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        23:00
                                    </div>
                                </div>
                                <div />
                            </div>

                            <!-- Vertical lines -->
                            <div
                                class="hidden grid-cols-7 col-start-1 col-end-2 grid-rows-1 row-start-1 divide-x divide-gray-100 sm:grid sm:grid-cols-7 dark:divide-zinc-700"
                            >
                                <div class="col-start-1 row-span-full" />
                                <div class="col-start-2 row-span-full" />
                                <div class="col-start-3 row-span-full" />
                                <div class="col-start-4 row-span-full" />
                                <div class="col-start-5 row-span-full" />
                                <div class="col-start-6 row-span-full" />
                                <div class="col-start-7 row-span-full" />
                                <div class="w-8 col-start-8 row-span-full" />
                            </div>

                            <!-- Events -->
                            <ol
                                class="grid grid-cols-1 col-start-1 col-end-2 row-start-1 sm:grid-cols-7 sm:pr-8"
                                style="grid-template-rows: 1.75rem repeat(288, minmax(0, 1fr)) auto"
                            >
                                <template v-for="(day, dayIndex) in days" :key="day.date">
                                    <li
                                        v-for="event in day.events"
                                        :key="event.id"
                                        class="relative flex mt-px"
                                        :class="[`sm:col-start-${dayIndex + 1}`]"
                                        :style="{
                                            gridRow: `
                                        ${12 * event.startHour + (2 * event.startMinute) / 30 + 2} / ${
                                            12 * event.endHour + (2 * event.endMinute) / 30 + 2
                                        }`,
                                        }"
                                    >
                                        <inertia-link
                                            :href="event.url"
                                            class="absolute flex flex-col p-2 overflow-y-auto text-xs leading-5 border rounded-lg group inset-1"
                                            :class="[
                                                `bg-${event.color}-100 hover:bg-${event.color}-100 border-${event.color}-400 dark:bg-${event.color}-700/30 dark:border-${event.color}-700 dark:hover:bg-${event.color}-900`,
                                            ]"
                                        >
                                            <p class="order-1 font-semibold" :class="[`text-${event.color}-700`]">
                                                {{ event.name }}
                                            </p>
                                            <p :class="[`text-${event.color}-500 group-hover:text-${event.color}-700`]">
                                                <time :datetime="event.blocking_calendar_from">{{ event.time }}</time>
                                            </p>
                                            <!-- eslint-disable -->
                                            <div class="order-2" v-html="event.instructor.avatar"></div>
                                            <!-- eslint-enable -->
                                        </inertia-link>
                                    </li>
                                </template>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </layout-box>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import CalendarNavigation from '@src/Reservations/Pages/Calendar/Partials/Navigation.vue';

const props = defineProps({
    date: {
        type: Object,
        default: () => ({
            day: null,
            month: null,
            year: null,
        }),
    },
    showViewSwitch: {
        type: Boolean,
        default: true,
    },
});

const showViewSwitch = ref(props.showViewSwitch);

const emit = defineEmits(['setView', 'setDate']);

const setView = (view: string) => emit('setView', view);

const container = ref(null);
const containerNav = ref(null);
const containerOffset = ref(null);

const days = ref([]);
const meta = ref({});

const getData = ({ day, month, year } = { day: null, month: null, year: null }) => {
    axios
        .get(route('reservations.calendar.api.week'), {
            params: {
                day,
                month,
                year,
            },
        })
        .then(({ data }) => {
            days.value = data.days;
            meta.value = data.meta;
        });
};

onMounted(() => {
    // Set the container scroll position based on the current time.
    const currentMinute = new Date().getHours() * 60;
    container.value.scrollTop =
        ((container.value.scrollHeight - containerNav.value.offsetHeight - containerOffset.value.offsetHeight) *
            currentMinute) /
        1440;

    getData(props.date);
});

const setDate = ({ day, month, year }) => {
    getData({ day, month, year });
    emit('setDate', { day, month, year });
};
</script>
